import { render, staticRenderFns } from "./TemplateFiveListCopy.vue?vue&type=template&id=99510808&scoped=true&"
import script from "./TemplateFiveListCopy.vue?vue&type=script&lang=js&"
export * from "./TemplateFiveListCopy.vue?vue&type=script&lang=js&"
import style0 from "./TemplateFiveListCopy.vue?vue&type=style&index=0&id=99510808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99510808",
  null
  
)

export default component.exports